import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIGetImportJobStatus, APIGetImportJobStatusParams, APIImportJobPost, APIImportJobPostParams, APIImportTypesGetList } from './Imports.api';

export const fetchImportTypes = createAsyncThunk('imports/fetchImportTypes', async (supportedTemplates : string[]) => {
    const response = await APIImportTypesGetList();
    return response.data.filter(t => supportedTemplates.some(s => s.toLowerCase() == t.name.toLowerCase()));
});

export const postImportJob = createAsyncThunk('imports/postImportJob', async (params: APIImportJobPostParams) => {
    const response = await APIImportJobPost(params);
    return response.data;
});

export const fetchImportJobStatus = createAsyncThunk('imports/fetchImportJobStatus', async (params: APIGetImportJobStatusParams) => {
    const response = await APIGetImportJobStatus(params);
    return response.data;
});
